import React from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import LinkHandler from 'components/atoms/LinkHandler'

import './NavigationLinks.scss'

function NavigationLinks({ classNav, items }) {
  return (
    <nav aria-label="Links de navegação" className="navigation-links">
      <ul className={`navigation-links--${classNav}`}>
        {items &&
          items.map(({ label, url, links }) => (
            <li key={label} className={`navigation-links--${classNav}__item`}>
              <LinkHandler className="text-primary" to={get(url, 'path')} title={label}>
                {classNav === 'sublist' && <i role="presentation" className="icone-chevron-right mr-2"></i>}
                {label}
              </LinkHandler>
              {links && links.length !== 0 ? <NavigationLinks items={links} classNav="sublist" /> : ''}
            </li>
          ))}
      </ul>
    </nav>
  )
}

NavigationLinks.propTypes = {
  classNav: PropTypes.oneOf(['list', 'sublist']),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.shape({
        path: PropTypes.string,
      }),
      links: PropTypes.arrayOf,
    })
  ),
}

export default NavigationLinks
